import { useState } from "react";


const useEnumState = (enumProperties, initialValue) => {
  if (!enumProperties.includes(initialValue)) 
    throw new Error("InvalidArugmentException: Initial State is not in Enumeration Properties");

  const [property, setProperty] = useState(initialValue);

  const setEnumProperty = (newEnumValue) => {
    if (!enumProperties.includes(newEnumValue)) 
      throw new Error("InvalidStateException: Trying to set Enumerated State to an invalid value");

    setProperty(newEnumValue);
  }
  
  return [property, setEnumProperty]
};

export default useEnumState;
